import { inject, Injectable } from '@angular/core';

import {
  createCoBrowsingFilter,
  ItemWithCompanyId,
} from '../../helpers/co-browsing-filter';
import { CoBrowsingSharedService } from './co-browsing.service';
import { CoBrowsingCompanyService } from './co-browsing-company.service';

@Injectable({
  providedIn: 'root',
})
export class CoBrowsingFilterService {
  private coBrowsingSharedService = inject(CoBrowsingSharedService);
  private coBrowsingCompanyService = inject(CoBrowsingCompanyService);

  createFilter<T extends ItemWithCompanyId>(
    userAccessType: string | null | undefined,
    isRestrictedRole: (accessType?: string | null) => boolean,
  ): (item: T) => boolean {
    return createCoBrowsingFilter({
      coBrowsingUserEmail:
        this.coBrowsingSharedService.getCoBrowsingUserEmail(),
      userAccessType,
      coBrowsingCompanyId:
        this.coBrowsingCompanyService.getCobrowsingCompany()?.companyId,
      isRestrictedRole,
    });
  }
}
